///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'h3[windeGridTitle], h4[windeGridTitle]',
    standalone: false
})
export class GirdTitleDirective {
    @HostBinding('class') buttonClass = 'winde-grid-title';
}
